import 'office-ui-fabric-react/dist/css/fabric.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import AdalConfig from './configAuth/AdalConfig';
import AuthContext from './configAuth/Auth';
import { Identification } from './Identification/Identification';
import Scriba from 'react-scriba';
import { Data } from './data/Data';
import logo from './images/logo-eiffage-immobilier.png';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import './Identification/Identification.css';
import { CompoundButton } from 'office-ui-fabric-react/lib/Button';
import { unregister } from './registerServiceWorker';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { ThemeSettingName } from 'office-ui-fabric-react';

class UnsupportedBrowserPage extends React.Component {

    render = () => {
        return <div className="container d-flex flex-column justify-content-center vh-100">
            <div className="alert alert-danger">
                Le navigateur que vous utilisez (Internet Explorer) n'est pas compatible avec cette version d'Immocom.<br />
                Nous vous recommandons de basculer sur l'un des navigateurs suivants :
                    Chrome (Version minimale :  79.0.3945.117),
                    Firefox (Version minimale : 70.0.1),
                    Edge (Version minimale : 44.18362.449.0)
            </div>
        </div>
    };

};

class ReinitialisationMotDePasse extends React.Component {

    constructor(props) {
        super(props);

        this.state = { motDePasse: "", errorMessage: "" };
    }

    //YD : 27/03/2020 => modification Regex
    _estMotDePasseValide = () => {
        const reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\\\-,?;.:/!§ù%*µ$£=+)°@^'{#&²|([_|])(?=.{8,})");
        return reg.test(this.state.motDePasse);
    };

    _getErrorMessage = () => {
        if (!this._estMotDePasseValide())
            return "Le mot de passe doit contenir au moins 8 caractères dont au moins 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial.";
        return "";
    };

    _onChange = (event, newValue) => {
        this.setState({ motDePasse: newValue });
    };

    _onEnregistrementMotDePasse = () => {
        this.setState({ errorMessage: '' });

        if (this._estMotDePasseValide()) {
            let onModificationDeMotDePasse = Data._onModificationDeMotDePasse(this.state.motDePasse, this.props.clef);

            onModificationDeMotDePasse
                .then(responseFetch => {
                    if (responseFetch.codeRetour === 0) {
                        window.location.href = "/";                       
                    }
                    else {
                        this.setState({ errorMessage: responseFetch.messageInfo });
                    }
                });
        }
    };

    render = () => {
        return <Stack horizontalAlign="center" verticalAlign="center" verticalFill className="containerIdentification">
            <div className="main-div">
                <img src={logo} alt="Logo" className="ms-hiddenMdDown" />
                <div>
                    <p className="ms-fontSize-xxl ms-textAlignCenter">Modification de mot de passe</p>
                </div>
                <div className="form-group">
                    <TextField
                        label="Nouveau mot de passe"
                        placeholder="Nouveau mot de passe"
                        required={true}
                        type='password'
                        errorMessage={this.state.errorMessage}
                        onGetErrorMessage={this._getErrorMessage}
                        onChange={this._onChange}
                    />
                </div>
                <div className="ms-textAlignCenter">
                    <CompoundButton
                        disabled={!this._estMotDePasseValide()}
                        onClick={this._onEnregistrementMotDePasse}
                        primary={true}
                        secondaryText="Valider votre nouveau mot de passe."
                        text="Enregistrer"
                    />
                </div>
            </div>
        </Stack>
    }
};

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

AuthContext.handleWindowCallback();

registerServiceWorker();
//unregister();

// *** M�thode permettant de d�finir l'authentification au niveau le plus haut de l'application, c�d que l'utilisateur n'a pas acc�s au contenu tant qu'il n'est pas authentifi� ***
function creationContent() {
    //normalement on doit avoir le jwt qui est renseign� uniquement lorsqu'on vient de la V2
    //on va donc v�rifier la valeur du p�rim�tre d�clar� dans cjeton afin de l'appliquer sur le site
    var jwt = Scriba.outils().getParameterByName('jwt');

    if (jwt !== null) {
        //********** JETON TRANSMIS ****************
        return <Identification onIdentification={() => onIdentification()} />
    }
    else {
        //on est dans le cas o� on acc�de directement � la version sans provenir de la V2, donc sans jeton
        if (sessionStorage.getItem('loginCompte') != null) {
            //*********** IDENTIFIE *******************
            return <BrowserRouter basename={baseUrl}>
                <App />
            </BrowserRouter>
        }
        else if ((window === window.parent) && window === window.top && !AuthContext.isCallback(window.location.hash)) {
            // Having both of these checks is to prevent having a token in localstorage, but no user.
            if (!AuthContext.getCachedToken(AdalConfig.clientId) || !AuthContext.getCachedUser()) {
                //********** PAS IDENTIFIE ****************

                if (window.location.pathname !== '/ModificationDeMotDePasse') {
                    return <Identification onIdentification={onIdentification} />
                }
                else {
                    const parametres = window.location.search.split('&');
                    const debut = 6; // ?clef=...
                    const clef = parametres[0].substring(debut, parametres[0].length);
                    return <ReinitialisationMotDePasse clef={clef} />;
                }
            } else {
                AuthContext.acquireToken(AdalConfig.endpoints.api, (message, token, msg) => {
                    if (token) {
                        return <Identification onIdentification={onIdentification} provenance="AAD" />
                    }
                });
            }
        }
        else {
            //********** PAS IDENTIFIE ****************
            return <Identification onIdentification={() => onIdentification()} />
        }
    }
}

function onIdentification() {
    let chargementGetUtilisateurConnecte = Data._chargementGetUtilisateurConnecte();

    chargementGetUtilisateurConnecte
        .then(responseFetch => {
            let estAutoriseAAccederAV4 = false;
            let cheminRedirection = "/"; // Redirection vers authentification V4

            if (responseFetch.codeRetour === 0) {
                const valeurRetour = responseFetch.reponseAPIobjet;
                const monCompte = valeurRetour[0];
                const urlV2 = valeurRetour[2];
                const jeton = valeurRetour[3];


                //YD : migration vers V4
                const migrationV4 = valeurRetour[8];
                if (migrationV4 === true) {
                    estAutoriseAAccederAV4 = true;

                    const searchTermReservation = '/Reservation/';
                    const indexOfFirstReservation = window.location.pathname.indexOf(searchTermReservation);

                    const searchTermModificationDeMotDePasse = "/ModificationDeMotDePasse";
                    const indexOfFirstModificationDeMotDePasse = window.location.pathname.indexOf(searchTermModificationDeMotDePasse);

                    if (indexOfFirstReservation !== -1 | indexOfFirstModificationDeMotDePasse !== -1)
                        cheminRedirection = window.location.pathname;
                }
                else {
                    //YD : 04/06/2020
                    //ajout de la récup de la plateforme afin de ne pas effectuer de redirection si plateforme != 'production'
                    const plateforme = valeurRetour[6];

                    const idsTypesMandatsAutorisesAAccederAV4 = [2, 7]; // 2 = Commercial ; 7 = Directeur commercial
                    const idTypeMandat = monCompte.sesMandats.length > 0 ? monCompte.sesMandats[0].idTypeMandat : -1; // Tous les mandats d'un utilisateur sont de types identiques
                    estAutoriseAAccederAV4 = (plateforme !== '' || monCompte.estAdminNational || idsTypesMandatsAutorisesAAccederAV4.includes(idTypeMandat));
                    cheminRedirection = estAutoriseAAccederAV4 ?
                        window.location.origin + window.location.pathname : // Redirection vers page d'accueil V4
                        urlV2 + "/AuthentificationJeton.aspx?Jwt=" + jeton + "&FctCall=MonAccueil.aspx"; // Redirection vers page d'accueil V2
                }
            }
            if (estAutoriseAAccederAV4)
                window.location.href = cheminRedirection;
            else {
                let _onDeconnexion = Data._onDeconnexion();

                _onDeconnexion
                    .then(() => {
                        // On supprime toute trace de connexion
                        sessionStorage.clear();
                        localStorage.clear();
                        AuthContext.logOut();
                        window.location.href = cheminRedirection;
                    });
            }
        });

    //ReactDOM.render(
    //    <div>
    //        <BrowserRouter basename={baseUrl}>
    //            <App />
    //        </BrowserRouter>
    //    </div>,
    //    rootElement);
}

//const UnsupportedBrowserPage = () => (
//    <div className="container d-flex flex-column justify-content-center vh-100">
//        <div className="alert alert-danger">
//            Le navigateur que vous utilisez (Internet Explorer) n'est pas compatible avec cette version d'Immocom.<br />
//            Nous vous recommandons de basculer sur l'un des navigateurs suivants :
//                Chrome (Version minimale :  79.0.3945.117),
//                Firefox (Version minimale : 70.0.1),
//                Edge (Version minimale : 44.18362.449.0)
//        </div>
//    </div>
//);

//const ReinitialisationMotDePasse = () => (
//    <div className="containerIdentification">
//        <div className="ms-Grid" dir="ltr">
//            <div className="ms-Grid-row">
//                <div className="login-form ms-Grid-col ms-sm12 ms-md12 ms-lg12">
//                    <div className="main-div">
//                        <img src={logo} alt="Logo" className="ms-hiddenMdDown" />
//                        <div>
//                            <p className="ms-fontSize-xxl ms-textAlignCenter">Modification de mot de passe</p>
//                        </div>
//                        <div className="form-group">
//                            <TextField
//                                label="Nouveau mot de passe"
//                                placeholder="Nouveau mot de passe"
//                                required={true}
//                                type='password'
//                                onGetErrorMessage={(value) => _getErrorMessage(value)}
//                                onChanged={valeur => mdp = valeur}
//                            />
//                        </div>
//                        <div className="ms-textAlignCenter">
//                            <CompoundButton primary={true} text="Enregistrer" secondaryText="Valider votre nouveau mot de passe." onClick={() => _onEnregistrementMotDePasse()}></CompoundButton>
//                        </div>
//                    </div>
//                </div>
//            </div>
//        </div>
//    </div>
//);

//function _getErrorMessage(mdp) {
//    let message = '';
//    const reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-+=_~@#$%^&*'`|{}:;!.,?()\"\\\[\\\]\\\/\\\\])(?=.{8,})");

//    if (!reg.test(mdp)) {
//        message = 'Le mot de passe doit contenir au moins 8 caractères dont au moins 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial.';
//        motDePasseValide = false;
//    }
//    else {
//        motDePasseValide = true;
//    }

function onRender() {
    const isBrowserIE = () => {
        const ua = window.navigator.userAgent;
        if (ua.indexOf('MSIE ') > 0) return true // IE < 11
        if (ua.indexOf('Trident/') > 0) return true // IE = 11
        return false;
    };

    if (isBrowserIE()) {
        ReactDOM.render(<UnsupportedBrowserPage />, rootElement);
    } else {
        ReactDOM.render(creationContent(), rootElement);
    }
}

onRender();

//ReactDOM.render(
//    <div>
//        {creationContent()}
//    </div>,
//    rootElement);



//if (sessionStorage.getItem('loginCompte') != null) {
//    //appel depuis V2 ou stockage du compte en session client
//    ReactDOM.render(
//        <BrowserRouter basename={baseUrl}>
//            <App />
//        </BrowserRouter>,
//        rootElement);
//}
//else {
//    ReactDOM.render(
//        <Identification />,
//        rootElement);
//}